export default __webpack_public_path__ + "static/media/landscape.2f132e36.svg";